<!-- begin:: Header Topbar -->
<div class="kt-header__topbar">
	<!--begin: Search -->
	<!-- <kt-search-dropdown [icon]="'./assets/media/icons/svg/General/Search.svg'" [useSVG]="true"></kt-search-dropdown> -->
	<!--end: Search -->
	<!--begin: Notifications -->
	<!-- <kt-notification [bgImage]="'./assets/media/misc/bg-1.jpg'" [pulse]="true" [skin]="'dark'" [icon]="'./assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true"></kt-notification> -->
	<!--end: Notifications -->
	<!--begin: Quick actions -->
	<!-- <kt-quick-action [bgImage]="'./assets/media/misc/bg-2.jpg'" [skin]="'dark'" [icon]="'./assets/media/icons/svg/Media/Equalizer.svg'" [useSVG]="true"></kt-quick-action> -->
	<!--end: Quick actions -->
	<!--begin: My Cart -->
	<!-- <kt-cart [bgImage]="'./assets/media/misc/bg-1.jpg'" [icon]="'./assets/media/icons/svg/Shopping/Cart3.svg'" [useSVG]="true"></kt-cart> -->
	<!--end: My Cart -->
	<!--begin: Quick panel toggler -->
	<!-- <div class="kt-header__topbar-item kt-header__topbar-item--quick-panel" data-placement="bottom" ngbTooltip="Quick panel">
		<span class="kt-header__topbar-icon" id="kt_quick_panel_toggler_btn">
			<span class="kt-svg-icon" [inlineSVG]="'./assets/media/icons/svg/Layout/Layout-4-blocks.svg'"></span>
		</span>
	</div> -->
	<!--end: Quick panel toggler -->
	<!--begin: Language bar -->
	<!-- <kt-language-selector></kt-language-selector> -->
	<!--end: Language bar -->
	<!--begin: Dev Switcher Trigger (invisible, left side) -->
	<div
		class="kt-header__topbar-item dev-switcher-trigger"
		(click)="onDevSwitcherTriggerClick()"
		*ngIf="shouldShowTrigger()">
		<div class="dev-switcher-trigger-area"></div>
	</div>
	<!--end: Dev Switcher Trigger -->
	<!--begin: Mode indicators (separate from user profile for independent hover) -->
	<ng-container *ngIf="(viewAsScopeService.scope$ | async) as scope">
		<div
			*ngIf="scope?.enabled && scope?.role"
			class="kt-header__topbar-item kt-header__topbar-item--mode-icon kt-hidden-mobile"
			[matTooltip]="viewAsScopeService.getViewAsTooltipText()"
			matTooltipPosition="above">
			<span class="kt-header__topbar-icon">
				<kt-lucide-icon name="Layers" [size]="18" [strokeWidth]="2"></kt-lucide-icon>
			</span>
		</div>
	</ng-container>
	<div
		*ngIf="isSuperAdmin && (demoModeService.demoMode$ | async)"
		class="kt-header__topbar-item kt-header__topbar-item--mode-icon kt-hidden-mobile"
		matTooltip="Demo mode"
		matTooltipPosition="above">
		<span class="kt-header__topbar-icon">
			<kt-lucide-icon name="Sparkles" [size]="18" [strokeWidth]="2"></kt-lucide-icon>
		</span>
	</div>
	<!--end: Mode indicators -->
	<!--begin: User bar -->
	<kt-user-profile></kt-user-profile>
	<!--end: User bar -->
</div>
<!-- end:: Header Topbar -->
